import { defineComponent } from "vue";
import { brightenKeyword } from "@/hooks/lightKeyword";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "SSheet",
  props: {
    sheetList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    inputValue: {
      type: String,
      default: ""
    }
  },
  setup: function setup() {
    var router = useRouter();
    /* 关键字高亮 */

    var lightKeyword = brightenKeyword;
    /* 歌单点击事件 */

    var sheetClick = function sheetClick(id) {
      router.push("/main/playlistdetail/".concat(id));
    };

    return {
      lightKeyword: lightKeyword,
      sheetClick: sheetClick
    };
  },
  components: {}
});